"use client";

/**
 * 読み込み中・処理中を示す共通ローダー（#1460）。
 *
 * 見た目とアニメーションは `globals.css` の `.loader-ring` / `.loader-dots` に置く。
 * どちらも単一要素の CSS のみで描画し、色は `currentColor` を継ぐため、置き場所の
 * 文字色クラス（`text-primary` など）でそのまま色が決まる。
 */

type LoaderProps = {
  /** ローダーの一辺（3点ローダーは横幅）。px で指定する */
  size?: number;
  /** 支援技術に読み上げさせる説明。既定は「読み込み中」 */
  label?: string;
  className?: string;
};

/** 円環が回るローダー。画面全体・領域全体の読み込み中に使う */
export function RingLoader({
  size = 40,
  label = "読み込み中",
  className,
}: LoaderProps) {
  return (
    <span
      role="status"
      aria-label={label}
      data-testid="ring-loader"
      className={className ? `loader-ring ${className}` : "loader-ring"}
      style={{ "--loader-size": `${size}px` } as React.CSSProperties}
    />
  );
}

/** 3点が上下するローダー。ボタンの中など文字と並べて使う */
export function DotsLoader({
  size = 24,
  label = "処理中",
  className,
}: LoaderProps) {
  return (
    <span
      role="status"
      aria-label={label}
      data-testid="dots-loader"
      className={className ? `loader-dots ${className}` : "loader-dots"}
      style={{ "--loader-size": `${size}px` } as React.CSSProperties}
    />
  );
}
